module.exports = "/_next/static/images/6d17cc780580906580d12b63bad202e1-phone-and-card@2x.png.webp";